import type {
  DatumEntity,
  LegacyWallHorizontalDatumEntity,
  LegacyWallVerticalDatumEntity,
} from "building-types/datums/datumEntityTypes";
import type {
  HorizontalJustification,
  VerticalJustification,
  WallHorizontalDatum,
  WallVerticalDatumAnchor,
} from "building-types/datums/datumsTypesEnum";
import uid from "common/utils/uid";
import { wallHorizontalDatumEntityNew, wallVerticalDatumEntityNew } from "doc/datums/datumEntityNew";

export function wallAssemblyVerticalDatumNew(
  name: string,
  anchor: WallVerticalDatumAnchor,
  justification: VerticalJustification,
  offset: number = 0,
  offsetNormalized: boolean = true,
): LegacyWallVerticalDatumEntity {
  return wallVerticalDatumEntityNew({
    name,
    sortIndex: 0,
    id: uid(),
    anchor,
    justification,
    offset,
    offsetNormalized,
  });
}

export function wallAssemblyHorizontalDatumNew(
  name: string,
  anchor: WallHorizontalDatum,
  justification: HorizontalJustification,
  offset: number = 0,
  offsetNormalized: boolean = true,
): LegacyWallHorizontalDatumEntity {
  return wallHorizontalDatumEntityNew({
    sortIndex: 0,
    id: uid(),
    name,
    anchor,
    justification,
    offset,
    offsetNormalized,
  });
}

export function mergeDatumOffset<T extends DatumEntity>(datum: T, offset?: number): T {
  if (!offset) {
    return datum;
  }

  return { ...datum, offset };
}
